import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Label,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Editor } from "../../../../../../Utils/Constants";
import FetchProductDataService from "../../../../../../Service/OPSServices/SWInternalServices/FetchProductDataService";
import ProductsAlertTicketCreateService from "../../../../../../Service/DashboardServices/TroubleTicketServices/ProductsAlertTicketCreateService";
import CreateNewTicketService from "../../../../../../Service/DashboardServices/TroubleTicketServices/CreateNewTicketService";
import {
  TicketProductList,
  LargeProductList,
} from "../../../TroubleTickets/TicketProductList";

function CreateNewTicketFromDash(props) {
  const storeIntegerId =
    props.store && props.store.integerID ? props.store.integerID : "";
  const storeName =
    props.store && props.store.name ? props.store.name : "";

  const [problemAreaList, setProblemAreaList] = useState([]);
  const [problemAreaPathwayList, setProblemAreaPathwayList] = useState([]);
  const [subRequestTypes, setSubRequestTypes] = useState([]);
  const [storeProducts, setStoreProducts] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [asinArray, setAsinArray] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [asinDisplayCondition, setAsinDisplayCondition] = useState(false);
  const [asinMandatory, setAsinMandatory] = useState(false);
  const [priority, setPriority] = useState("Normal");
  const [isInternalTicket, setIsInternalTicket] = useState(
    props.accessLevel == 0 ? true : false
  );

  // "" = multi/all select mode; set to a specific ASIN for single-product mode
  const asinForTicketList =
    props.asinForTicketList != null && props.asinForTicketList !== false
      ? props.asinForTicketList
      : "";

  const [formData, setFormData] = useState({
    ticketTitle: "",
    mainRequestType: 2,
    selectedProblemArea: "",
    selectedProblemPathWay: "",
    subRequestTypes: "",
    product: asinForTicketList ? asinForTicketList : [],
    integerId: storeIntegerId,
    storeName: storeName,
    sku: "",
    ticketHistoryComment: "",
    isInternalTicket: props.accessLevel == 0 ? true : false,
    createrPriority: "Normal",
  });

  useEffect(() => {
    ProductsAlertTicketCreateService(props.token).then((res) => {
      if (res) {
        setProblemAreaList(res.problemAreaList || []);
        setProblemAreaPathwayList(res.problemAreaPathwayList || []);
        setSubRequestTypes(res.subRequestTypes || []);
      }
    });
  }, [props.token]);

  useEffect(() => {
    if (!storeIntegerId) {
      setStoreProducts([]);
      return;
    }
    setProductsLoading(true);
    FetchProductDataService(props.token, { integerID: storeIntegerId }).then(
      (res) => {
        setProductsLoading(false);
        if (res) {
          const list = Array.isArray(res)
            ? res
            : res.productsList ||
              res.productList ||
              res.products ||
              res.storeProducts ||
              [];
          setStoreProducts(list);
        } else {
          setStoreProducts([]);
        }
      }
    );
    setFormData((prev) => ({
      ...prev,
      integerId: storeIntegerId,
      storeName: storeName,
    }));
  }, [props.token, storeIntegerId, storeName]);

  useEffect(() => {
    // Pre-select single ASIN when passed from parent
    if (asinForTicketList) {
      setAsinArray([asinForTicketList]);
      setFormData((prev) => ({ ...prev, product: [asinForTicketList] }));
    }
  }, [asinForTicketList]);

  const filteredProductList = storeProducts.filter((row) => {
    const asin = (row.asin || "").toLowerCase();
    const productTitle = (row.productTitle || "").toLowerCase();
    const skus = row.skus ? row.skus.join("").toLowerCase() : "";
    if (!query) return true;
    const q = query.toLowerCase();
    return (
      asin.includes(q) ||
      productTitle.includes(q) ||
      skus.includes(q)
    );
  });

  const updateAsinDisplayFlags = (subTypeId) => {
    const type = subRequestTypes.find((t) => String(t.id) === String(subTypeId));
    setAsinDisplayCondition(type ? !!type.asinDisplay : false);
    setAsinMandatory(type ? !!type.asinMandatory : false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "selectedProblemArea") {
      setFormData({
        ...formData,
        selectedProblemArea: value,
        selectedProblemPathWay: "",
        subRequestTypes: "",
      });
      setAsinDisplayCondition(false);
      setAsinMandatory(false);
    } else if (name === "selectedProblemPathWay") {
      setFormData({
        ...formData,
        selectedProblemPathWay: value,
        subRequestTypes: "",
      });
      setAsinDisplayCondition(false);
      setAsinMandatory(false);
    } else if (name === "subRequestTypes") {
      setFormData({ ...formData, [name]: value });
      updateAsinDisplayFlags(value);
    } else if (name === "isInternalTicket") {
      setIsInternalTicket(e.target.checked);
      setFormData({ ...formData, isInternalTicket: e.target.checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlePriorityChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setPriority(value);
  };

  const handleQuillChange = (value) => {
    setFormData({ ...formData, ticketHistoryComment: value });
  };

  const handleFileChange = (e) => {
    const newFiles = [...selectedFiles];
    for (let i = 0; i < e.target.files.length; i++) {
      newFiles.push(e.target.files[i]);
    }
    setSelectedFiles(newFiles);
  };

  const handleRemoveFile = (file) => {
    setSelectedFiles(selectedFiles.filter((f) => f !== file));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    let updatedArray;
    if (e.target.checked) {
      updatedArray = asinArray.includes(value)
        ? asinArray
        : [...asinArray, value];
    } else {
      updatedArray = asinArray.filter((asin) => asin !== value);
    }
    setAsinArray(updatedArray);
    setFormData({ ...formData, product: updatedArray });
  };

  const handleSelectAllProducts = (e) => {
    if (e.target.checked) {
      const allAsins = filteredProductList.map((p) => p.asin);
      setAsinArray(allAsins);
      setFormData({ ...formData, product: allAsins });
    } else {
      setAsinArray([]);
      setFormData({ ...formData, product: [] });
    }
  };

  const handleClearSearch = () => {
    setQuery("");
  };

  const isAllFilteredSelected =
    filteredProductList.length > 0 &&
    filteredProductList.every((p) => asinArray.includes(p.asin));

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const newFormData = new FormData();
    newFormData.append("ticketTitle", formData.ticketTitle);
    newFormData.append("internalCommunication", false);
    newFormData.append("mainRequestType", 2);
    newFormData.append("problemAreaId", formData.selectedProblemArea);
    newFormData.append("problemAreaPathwayId", formData.selectedProblemPathWay);
    newFormData.append("subRequestType", formData.subRequestTypes);
    newFormData.append(
      "asin",
      Array.isArray(formData.product)
        ? formData.product.join(",")
        : formData.product || ""
    );
    newFormData.append("sku", formData.sku || "");
    newFormData.append("integerId", formData.integerId);
    newFormData.append("storeName", formData.storeName);
    newFormData.append("amazonCaseId", "");
    newFormData.append("amazonCaseUrl", "");
    newFormData.append("createrPriority", formData.createrPriority);
    newFormData.append("isInternalTicket", isInternalTicket);
    newFormData.append("ticketHistoryComment", formData.ticketHistoryComment);

    for (let i = 0; i < selectedFiles.length; i++) {
      newFormData.append("ticketAttachmentFile", selectedFiles[i]);
    }

    CreateNewTicketService(props.token, newFormData).then((response) => {
      setLoading(false);
      if (response) {
        if (props.handleCreateAndViewTicketClose) {
          props.handleCreateAndViewTicketClose(response);
        } else if (props.handleCloseCreateTicketPopup) {
          props.handleCloseCreateTicketPopup(response);
        }
      }
    });
  };

  const productRequiredOk =
    !asinMandatory ||
    (Array.isArray(formData.product)
      ? formData.product.length > 0
      : !!formData.product);

  const canSubmit =
    formData.ticketHistoryComment &&
    formData.selectedProblemArea &&
    formData.selectedProblemPathWay &&
    formData.subRequestTypes &&
    formData.integerId &&
    productRequiredOk &&
    !loading;

  return (
    <Container fluid className="">
      <Row className="justify-content-center p-3">
        <Col md="12" className="mbg-3 font-size-lg p-0">
          <Card className="main-card border-0">
            <form onSubmit={handleSubmit}>
              <Row className="p-4 mt-1">
                <Col md={3} className="mt-2">
                  <label htmlFor="selectedProblemArea">
                    <b>
                      {"1)"} Problem Area
                      <span style={{ color: "red" }}> *</span> :
                    </b>
                  </label>
                </Col>
                <Col md={9} className="mt-2">
                  <select
                    id="selectedProblemArea"
                    name="selectedProblemArea"
                    value={formData.selectedProblemArea}
                    onChange={handleInputChange}
                    className="form-control w-50"
                  >
                    <option value="">--Select Problem Area--</option>
                    {problemAreaList.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.problemArea}
                      </option>
                    ))}
                  </select>
                </Col>

                <Col md={3} className="mt-2">
                  <label htmlFor="selectedProblemPathWay">
                    <b>
                      {"2)"} Problem Pathway
                      <span style={{ color: "red" }}> *</span> :
                    </b>
                  </label>
                </Col>
                <Col md={9} className="mt-2">
                  <select
                    id="selectedProblemPathWay"
                    name="selectedProblemPathWay"
                    value={formData.selectedProblemPathWay}
                    onChange={handleInputChange}
                    className="form-control w-50"
                  >
                    <option value="">--Select Problem Pathway--</option>
                    {problemAreaPathwayList.map((type) =>
                      String(formData.selectedProblemArea) ===
                      String(type.problemAreaId) ? (
                        <option key={type.id} value={type.id}>
                          {type.problemAreaPathway}
                        </option>
                      ) : null
                    )}
                  </select>
                </Col>

                <Col md={3} className="mt-2">
                  <label htmlFor="subRequestTypes">
                    <b>
                      {"3)"} Problem Type
                      <span style={{ color: "red" }}> *</span> :
                    </b>
                  </label>
                </Col>
                <Col md={9} className="mt-2">
                  <select
                    id="subRequestTypes"
                    name="subRequestTypes"
                    value={formData.subRequestTypes}
                    onChange={handleInputChange}
                    className="form-control w-50"
                  >
                    <option value="">--Select Problem Type--</option>
                    {subRequestTypes.map((type) =>
                      String(formData.selectedProblemPathWay) ===
                      String(type.problemAreaPathwayId) ? (
                        <option key={type.id} value={type.id}>
                          {type.requestSubTypes}
                        </option>
                      ) : null
                    )}
                  </select>
                </Col>

                <Col md={12} className="mt-3">
                  <ReactQuill
                    theme={"snow"}
                    modules={Editor.modules}
                    formats={Editor.formats}
                    value={formData.ticketHistoryComment}
                    onChange={handleQuillChange}
                    bounds={".quill-prod"}
                    placeholder="Add Your Comments Here"
                  />
                </Col>

                <Col md={4} className="mt-4 d-flex">
                  <label className="w-25 mt-1">
                    <b>Priority : </b>
                  </label>
                  <select
                    id="createrPriority"
                    name="createrPriority"
                    onChange={handlePriorityChange}
                    value={priority}
                    className="form-control w-50"
                  >
                    <option value="Critical">Critical</option>
                    <option value="Urgent">Urgent</option>
                    <option value="High">High</option>
                    <option value="Normal">Normal</option>
                    <option value="Low">Low</option>
                  </select>
                </Col>

                <Col md={4} className="mt-4">
                  <label
                    htmlFor="fileInput"
                    className="custom-file-input-label text-center"
                  >
                    <i className="fas fa-upload"></i>
                    <br /> Choose File
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    name="ticketAttachment"
                    className="custom-file-input"
                    onChange={handleFileChange}
                    multiple
                  />
                </Col>
                <Col md={4} className="mt-4">
                  <span style={{ fontSize: "13px" }}>Attached File List</span>
                  <ul style={{ color: "green", fontSize: "13px" }}>
                    {selectedFiles.map((file, index) => (
                      <li key={index}>
                        {file.name}
                        <button
                          type="button"
                          className="btn"
                          onClick={() => handleRemoveFile(file)}
                        >
                          <FontAwesomeIcon
                            color="red"
                            size="15px"
                            icon={faWindowClose}
                          />
                        </button>
                      </li>
                    ))}
                  </ul>
                </Col>

                <Col md={12} className="mt-3">
                  <Row className="align-items-center">
                    <Col md={6}>
                      <label htmlFor="">
                        <b>
                          Product(s)
                          {asinMandatory ? (
                            <span style={{ color: "red" }}> *</span>
                          ) : null}{" "}
                          :
                        </b>
                      </label>
                      {!asinForTicketList && filteredProductList.length > 0 ? (
                        <Label className="ml-3 mb-0">
                          <Input
                            type="checkbox"
                            checked={isAllFilteredSelected}
                            onChange={handleSelectAllProducts}
                          />{" "}
                          <b>
                            Select All ({asinArray.length}/
                            {filteredProductList.length})
                          </b>
                        </Label>
                      ) : null}
                    </Col>
                    <Col md={6}>
                      <Row
                        className={
                          storeProducts.length > 0 ? "" : " d-none "
                        }
                      >
                        <Col
                          md={2}
                          className="mt-2 justify-content-end d-flex "
                        >
                          {query ? (
                            <FontAwesomeIcon
                              onClick={handleClearSearch}
                              color="red"
                              style={{ cursor: "pointer" }}
                              size="15px"
                              icon={faUndo}
                            />
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col md={10}>
                          <input
                            className="form-control "
                            type="text"
                            placeholder="Search product by Title, ASIN or SKU"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {productsLoading ? (
                    <p className="text-center mt-2">Loading products...</p>
                  ) : !storeIntegerId ? (
                    <p className="text-center mt-2 text-muted">
                      Please select a store to load products.
                    </p>
                  ) : filteredProductList.length > 300 ? (
                    <LargeProductList
                      filteredProductList={filteredProductList}
                      asinForTicketList={asinForTicketList}
                      handleChange={handleChange}
                      asinArray={asinArray}
                    />
                  ) : (
                    <TicketProductList
                      filteredProductList={filteredProductList}
                      asinForTicketList={asinForTicketList}
                      handleChange={handleChange}
                      asinArray={asinArray}
                    />
                  )}
                </Col>
              </Row>

              <p className="mt-3 text-center">
                {props.accessLevel == 0 ? (
                  <Label className="text-center">
                    <Input
                      type="checkbox"
                      name="isInternalTicket"
                      checked={isInternalTicket}
                      onChange={handleInputChange}
                    />
                    <span>
                      <b> Is it an internal ticket?</b>
                    </span>
                  </Label>
                ) : (
                  ""
                )}
                <Button
                  className="btn_class"
                  type="submit"
                  disabled={!canSubmit}
                >
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </p>
            </form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    globalPermissions: state.loggedUser.globalPermissions,
    UserPermission: state.accountOverview.store.StoreUserPermission,
  };
};

export default connect(mapStateToProps)(CreateNewTicketFromDash);
